import React, { useEffect, useRef } from "react";
import styled from "@emotion/styled";
import UserMessage from "./UserMessage";
import SystemMessage from "./SystemMessage";
import LinkMessage from "./LinkMessage";
import useAppStore from "../appStore";
import ThinkingIndicator from "./ThinkingIndicator";

const Conversation = ({ messages }) => {
  const containerRef = useRef();
  const chatOpen = useAppStore((state) => state.chatOpen);
  useEffect(() => {
    if (!chatOpen) return;
    const scrollToBottom = () => {
      if (containerRef.current) {
        containerRef.current.scrollTo({
          top: containerRef.current.scrollHeight,
          behavior: "smooth",
        });
      }
    };
    
    if (containerRef.current) {
      // containerRef.current.scrollTo({
      //   top: containerRef.current.scrollHeight,
      //   behavior: "smooth",
      // });
      setTimeout(scrollToBottom, 200);

    }

  }, [messages, chatOpen]);

  const isBotThinking = useAppStore((state) => state.isAITyping);

  useEffect(() => {
    if (!chatOpen) return;
    const scrollToBottom = () => {
      if (containerRef.current) {
        containerRef.current.scrollTo({
          top: containerRef.current.scrollHeight,
          behavior: "smooth",
        });
      }
    };

    if (isBotThinking) {
      // Wait for the ThinkingIndicator to be rendered in DOM
      setTimeout(scrollToBottom, 200);
    } else {
      scrollToBottom();
    }
  }, [messages, chatOpen, isBotThinking]);

  const renderMessages = () => {
    if (messages.length === 0) {
      return null;
    }

    return messages.map((message, index) => {
      if (message.type === "human") {
        return (
          <UserMessage
            messages={messages}
            messageNumber={index}
            key={index}
            text={message.content}
          />
        );
      }

      if (message.link !== undefined) {
        // console.log("got a link message")
        return (
          <LinkMessage
            messages={messages}
            messageNumber={index}
            key={index}
            text={message.content}
            link={message.link}
            metadata={message.metadata}
          />
        );
      }
      return (
        <SystemMessage
          messages={messages}
          messageNumber={index}
          key={index}
          text={message.content}
        />
      );
    });
  };
  return (
    <StyledConversation ref={containerRef}>
      {renderMessages()}
      <ThinkingIndicator></ThinkingIndicator>
    </StyledConversation>
  );
};

const StyledConversation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 14px;
  overflow: auto;
  height: calc(100% - 100px);
  padding-bottom: 35px;
  &::-webkit-scrollbar {
    width: 0px;
  }
`;

export default Conversation;
